import type { DriftStatus } from "../api/types";

interface DriftBadgeProps {
  drift: DriftStatus;
  compact?: boolean;
}

const TONE: Record<DriftStatus, { bg: string; fg: string; label: string; tooltip: string }> = {
  aligned: {
    bg: "transparent",
    fg: "var(--text-dim)",
    label: "✓",
    tooltip: "Aligned: in inventory and live in HA",
  },
  intent_only: {
    bg: "rgba(251, 191, 36, 0.16)",
    fg: "var(--warn)",
    label: "Intent only",
    tooltip: "In inventory but not currently observed in HA — pending pairing or disconnected",
  },
  reality_only: {
    bg: "rgba(94, 234, 212, 0.16)",
    fg: "var(--accent)",
    label: "Rogue",
    tooltip: "In HA but not in inventory — likely a new device that needs to be added to localtuya_reservations.yml",
  },
};

export function DriftBadge({ drift, compact = false }: DriftBadgeProps) {
  const tone = TONE[drift] ?? TONE.aligned;
  return (
    <span
      title={tone.tooltip}
      style={{
        display: "inline-flex",
        alignItems: "center",
        padding: compact ? "1px 6px" : "2px 10px",
        borderRadius: 999,
        background: tone.bg,
        color: tone.fg,
        fontSize: compact ? "0.7rem" : "0.75rem",
        fontWeight: 600,
      }}
    >
      {tone.label}
    </span>
  );
}
